// extracted by mini-css-extract-plugin
export default {"formulario":"editModal_formulario__kbGHR"};